var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ACB3BE",
    d: "m16.14 15.01 3.625 3.624a.802.802 0 0 1-1.131 1.133l-3.625-3.627a6.8 6.8 0 1 1 1.131-1.13Zm-1.613-.585a5.2 5.2 0 1 0-.101.102.806.806 0 0 1 .101-.101Z"
  })));
};
export default SvgSearch;